import { parseSettings } from 'app/pages/companies/tpoSignupConfigurations/TpoSignupConfigurationDrawer/TpoSignupConfigurationDrawer.constants';
import _ from 'lodash';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

const selectTpoSignupConfigurations = createSelector(
  getCompany,
  ({ tpoSignupConfigurations }) => tpoSignupConfigurations,
);

export const selectTpoSignupConfigurationsList = createSelector(
  selectTpoSignupConfigurations,
  ({ list }) => list,
);

export const selectTpoSignupConfigurationsTotalCount = createSelector(
  selectTpoSignupConfigurationsList,
  list => list.length,
);

export const selectFilteredTpoSignupConfigurations = createSelector(
  getDebouncedSearchValue,
  selectTpoSignupConfigurationsList,
  searchItems(config => {
    const parsed = parseSettings(config);
    const channelTypes = parsed.channelTypes || [];

    const channelNames = channelTypes.map(entry => (_.isObject(entry) ? entry.name : entry));

    return [config.name, ...channelNames];
  }),
);

export const selectTpoSignupStepConditionExpressionSchema = createSelector(
  getCompany,
  ({ tpoSignupStepConditionExpressionSchema }) => tpoSignupStepConditionExpressionSchema,
);
